import { css } from '@emotion/css';
import { StoreUserBetRH } from 'models/rong-ho-model';
import { useEffect, useMemo, useRef, useState } from 'react';
import { animateValue } from 'utils/function';
import winSound from 'assets/images/audio/winSound.mp3';

interface Props {
    stateBtnBet: '' | 'RONG' | 'HO' | 'HOA';
    onSelectPlace: (value: 'RONG' | 'HO' | 'HOA', placeEl: Element) => void;
    moneyCountTai: number;
    moneyCountXiu: number;
    moneyCountHoa: number;
    countConfirmBet: StoreUserBetRH;
    result: string[] | null;
    countUser: StoreUserBetRH;
}

export default function PlaceBetRongHo(props: Props) {
    const { stateBtnBet, onSelectPlace, moneyCountTai, moneyCountXiu, moneyCountHoa, countConfirmBet, result, countUser } = props;

    const moneyTaiRef = useRef<HTMLDivElement>(null);
    const moneyXiuRef = useRef<HTMLDivElement>(null);
    const moneyHoaRef = useRef<HTMLDivElement>(null);
    const winSoundAudio = useMemo(() => new Audio(winSound), []);

    const moneyCurrentPlaceRef = useRef<{ rong: number; ho: number; hoa: number }>({ rong: 0, hoa: 0, ho: 0 });

    const [placeWin, setPlaceWin] = useState<'RONG' | 'HO' | 'HOA' | ''>('');

    useEffect(() => {
        if (result) {
            const long = Number(result[0].split('-')?.[0]);
            const ho = Number(result[1].split('-')?.[0]);
            if (long > ho) {
                setPlaceWin('RONG');
            } else if (long < ho) {
                setPlaceWin('HO');
            } else {
                setPlaceWin('HOA');
            }
            winSoundAudio.play();
        } else {
            setPlaceWin('');
        }
    }, [result]);

    useEffect(() => {
        if (moneyCountTai === 0) {
            moneyCurrentPlaceRef.current.rong = 0;
        }
        if (moneyCountTai > moneyCurrentPlaceRef.current.rong && moneyTaiRef.current) {
            animateValue(moneyTaiRef.current, moneyCurrentPlaceRef.current.rong, moneyCountTai, 200, () => {
                moneyCurrentPlaceRef.current.rong = moneyCountTai;
            });
        }
    }, [moneyCountTai]);

    useEffect(() => {
        if (moneyCountXiu === 0) {
            moneyCurrentPlaceRef.current.ho = 0;
        }
        if (moneyCountXiu > moneyCurrentPlaceRef.current.ho && moneyXiuRef.current) {
            animateValue(moneyXiuRef.current, moneyCurrentPlaceRef.current.ho, moneyCountXiu, 200, () => {
                moneyCurrentPlaceRef.current.ho = moneyCountXiu;
            });
        }
    }, [moneyCountXiu]);

    useEffect(() => {
        if (moneyCountHoa === 0) {
            moneyCurrentPlaceRef.current.hoa = 0;
        }
        if (moneyCountHoa > moneyCurrentPlaceRef.current.hoa && moneyHoaRef.current) {
            animateValue(moneyHoaRef.current, moneyCurrentPlaceRef.current.hoa, moneyCountHoa, 200, () => {
                moneyCurrentPlaceRef.current.hoa = moneyCountHoa;
            });
        }
    }, [moneyCountHoa]);

    const selectPlace = (value: 'RONG' | 'HO' | 'HOA', event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const targetEl = event.target as HTMLElement;
        const btnEl = targetEl.closest('.place-item');
        if (btnEl) {
            onSelectPlace(value, btnEl);
        }
    };

    return (
        <div className={styles.placeBetRH}>
            <div
                data-infinity="RONG"
                className={`place-item ${stateBtnBet === 'RONG' ? 'active' : ''} ${placeWin === 'RONG' ? 'place-win' : ''} ${
                    placeWin && placeWin !== 'RONG' ? 'place-lose' : ''
                }
                `}
                onClick={(e) => selectPlace('RONG', e)}
            >
                <img className="place-img" src={require(`assets/images/rongho/place-rong.png`)} alt='' />
                <img className="win-bg" src={require(`assets/images/rongho/place-rong-win.png`)} alt='' />
                <div className="place-inner">
                    <div className="place-content">
                        {countConfirmBet.tai > 0 && (
                            <p className="money-confirm">{new Intl.NumberFormat().format(countConfirmBet.tai)}</p>
                        )}
                        <div className="count-users">
                            <p>{countUser.tai}</p>
                            <img src={require(`assets/images/rongho/icon-users.png`)} />
                        </div>
                        <div className="text-place">
                            <img className="text-img" src={require(`assets/images/rongho/text-rong.png`)} alt='' />
                            <p className="text-ratio">1:0.98</p>
                        </div>
                        <div className="count-bet">
                            <img className="icon-money" src={require(`assets/images/rongho/money.png`)} alt='' />
                            <p ref={moneyTaiRef}>{new Intl.NumberFormat().format(moneyCountTai || 0)}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div
                data-infinity="HOA"
                className={`place-item ${stateBtnBet === 'HOA' ? 'active' : ''} ${placeWin === 'HOA' ? 'place-win' : ''} ${
                    placeWin && placeWin !== 'HOA' ? 'place-lose' : ''
                }`}
                onClick={(e) => selectPlace('HOA', e)}
            >
                <img className="place-img" src={require(`assets/images/rongho/place-hoa.png`)} alt='' />
                <img className="win-bg" src={require(`assets/images/rongho/place-hoa-win.png`)} alt='' />
                <div className="place-inner">
                    <div className="place-content">
                        {countConfirmBet.hoa > 0 && (
                            <p className="money-confirm">{new Intl.NumberFormat().format(countConfirmBet.hoa)}</p>
                        )}
                        <div className="count-users">
                            <p>{countUser.hoa}</p>
                            <img src={require(`assets/images/rongho/icon-users.png`)} />
                        </div>
                        <div className="text-place">
                            <img className="text-img" src={require(`assets/images/rongho/text-hoa.png`)} alt='' />
                            <p className="text-ratio">1:8</p>
                        </div>
                        <div className="count-bet">
                            <img className="icon-money" src={require(`assets/images/rongho/money.png`)} alt='' />
                            <p ref={moneyHoaRef}>{new Intl.NumberFormat().format(moneyCountHoa || 0)}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div
                data-infinity="HO"
                className={`place-item ${stateBtnBet === 'HO' ? 'active' : ''} ${placeWin === 'HO' ? 'place-win' : ''} ${
                    placeWin && placeWin !== 'HO' ? 'place-lose' : ''
                }
                `}
                onClick={(e) => selectPlace('HO', e)}
            >
                <img className="place-img" src={require(`assets/images/rongho/place-ho.png`)} alt='' />
                <img className="win-bg" src={require(`assets/images/rongho/place-ho-win.png`)} alt='' />

                <div className="place-inner">
                    <div className="place-content">
                        {countConfirmBet.xiu > 0 && (
                            <p className="money-confirm">{new Intl.NumberFormat().format(countConfirmBet.xiu)}</p>
                        )}
                        <div className="count-users">
                            <p>{countUser.xiu}</p>
                            <img src={require(`assets/images/rongho/icon-users.png`)} />
                        </div>
                        <div className="text-place">
                            <img className="text-img" src={require(`assets/images/rongho/text-ho.png`)} alt='' />
                            <p className="text-ratio">1:0.98</p>
                        </div>
                        <div className="count-bet">
                            <img className="icon-money" src={require(`assets/images/rongho/money.png`)} alt='' />
                            <p ref={moneyXiuRef}>{new Intl.NumberFormat().format(moneyCountXiu || 0)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    placeBetRH: css`
        display: flex;
        padding: 2px;
        gap: 4;
        .place-item {
            position: relative;
            border: 2px solid #333;
            margin: 3px;
            border-radius: 12px;
            img {
                height: 100%;
                width: 100%;
            }
            &.place-win {
                .win-bg {
                    opacity: 1;
                }
            }
            &.place-lose {
                .place-img {
                    filter: grayscale(1);
                }
            }
            &.active {
                &::before {
                    display: block;
                }
            }
            &::before {
                content: '';
                position: absolute;
                top: -2px;
                left: -2px;
                height: 97%;
                width: 100%;
                background: transparent;
                border: 2px solid var(--ion-color-secondary);
                border-radius: 12px;
                pointer-events: none;
                display: none;
                z-index: 1;
            }
            .win-bg {
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
            }
            .place-inner {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                .place-content {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    flex-direction: column;
                    padding-bottom: 4px;
                    .text-place {
                        text-align: center;
                        .text-img {
                            height: 34px;
                        }
                        .text-ratio {
                            font-size: 11px;
                            font-weight: 700;
                            color: var(--ion-color-text-primary);
                        }
                    }
                    .count-users {
                        position: absolute;
                        top: 2px;
                        right: 2px;
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        img {
                            width: 14px;
                        }
                        p {
                            font-size: 12px;
                            font-weight: 500;
                            color: var(--ion-color-custom-white);
                        }
                    }
                    .count-bet {
                        position: relative;
                        background: #3e2971;
                        width: 80%;
                        margin: 20px auto 10px;
                        border-radius: 20px;
                        p {
                            width: 100%;
                            text-align: right;
                            display: block;
                            padding-right: 6px;
                            font-size: 15px;
                            font-weight: 600;
                            color: rgba(255, 185, 65, 1);
                        }
                        img {
                            width: 20px;
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            left: -4px;
                        }
                    }
                    .money-confirm {
                        border: 1px solid #893915;
                        border-radius: 5px;
                        box-shadow: inset 1px 1px 1px #fff;
                        background: var(--ion-color-secondary);
                        font-size: 11px;
                        color: var(--ion-color-custom-22);
                        font-weight: 700;
                        padding: 2px 4px;
                        z-index: 1;
                    }
                }
            }
        }
    `,
};
